import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiContenteditableService } from '@fi-shared/fi-contenteditable/fi-contenteditable.service';
import { FiContenteditableComponent } from './fi-contenteditable.component';
import { FormsModule } from '@angular/forms';
import { FiAutofocusModule } from '@fi-shared/fi-directives/autofocus/autofocus.module';
import { FiReplaceWithLinksModule } from '@fi-shared/fi-directives/replace-with-links/replace-with-links.module';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
    imports: [CommonModule, FormsModule, FiAutofocusModule, FiReplaceWithLinksModule],
    declarations: [FiContenteditableComponent],
    exports: [FiContenteditableComponent],
    providers: [FiContenteditableService],
})
export class FiContenteditableModule {}
